<template>
    <PopupRouterView :showLeftIcon="true" label="Delivery Instruction Status Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="deliveryinstructionstatus"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="deliveryInstructionStatusInput">


        <b-card header="Delivery Instruction Status" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Code" label-for="input-code" size="sm" :model.sync="model.code" :isRequired="true" :state="validateState('code')" :errorMessage="getErrorMessage(errorMessage.code, 'code')"   />
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"   />
						<app-input-textbox id="fieldset-sequence" label-cols-lg="12"  label="Sequence" label-for="input-sequence" size="sm" type="number" :model.sync="model.sequence"   />
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"   />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DeliveryInstructionStatus from '@/models/DeliveryInstructionStatus/DeliveryInstructionStatus';
import DeliveryInstructionStatusList from '@/models/DeliveryInstructionStatus/DeliveryInstructionStatusList';
import DeliveryInstructionStatusFilter from '@/filters/DeliveryInstructionStatus/DeliveryInstructionStatusFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			code: {required},
			name: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				code: { required : "Code is Required."},
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterDeliveryInstructionStatus : null,
			currentDeliveryInstructionStatusPage : 1,
			deliveryInstructionStatusPageSize: 10,
			sortByDeliveryInstructionStatus: '',
			sortDescDeliveryInstructionStatus: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getDeliveryInstructionStatus : async function(id) {
			this.isBusy = true;
			DeliveryInstructionStatus.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDeliveryInstructionStatus = true;
			this.filterDeliveryInstructionStatus.id = this.modelId;
			DeliveryInstructionStatus.downloadDataDetail(this, this.filterDeliveryInstructionStatus).then(result => {
				this.isDownloadDeliveryInstructionStatus = false;
			}).catch(error => { this.isDownloadDeliveryInstructionStatus = false; })
		},
		getDeliveryInstructionStatuss : async function(input) {
			let filter = new DeliveryInstructionStatusFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isDeliveryInstructionStatusComboLoading = true;
			DeliveryInstructionStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionStatuss = result.data
				}
				this.isDeliveryInstructionStatusComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.deliveryInstructionStatusInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						DeliveryInstructionStatus.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'deliveryinstructionstatusindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						DeliveryInstructionStatus.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'deliveryinstructionstatusindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryInstructionStatus.updateData(this, model, id)
					.catch((error) => {
						this.getDeliveryInstructionStatus(id);
					});
				}
			});
		},
		onHidden() {
			this.getDeliveryInstructionStatuss();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterDeliveryInstructionStatus = new DeliveryInstructionStatusFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDeliveryInstructionStatus(id);
			} else {
				this.modelId = id;
				this.getDeliveryInstructionStatus(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
